export default "__VITE_PUBLIC_ASSET__136cac8b__"